module.exports = __webpack_public_path__ + "img/caret-square-down.d6629087.svg";